import { IconButton } from "@mui/material";
import React from "react";
import DeleteIcon from "./icon/DeleteIcon";

export default function DeleteBtn({ handleDelete, ...props }) {
  return (
    <IconButton
      {...props}
      onClick={handleDelete}
      sx={{ width: "32px", height: "32px", background: "var(--grey) !important", color: props.disabled ? "#b0b0b0" : "#000" }}
    >
      <DeleteIcon />
    </IconButton>
  );
}
